import { NavigateFunction, Location } from "react-router-dom";
class UrlHelper {
  static getQueryParam = (search: string, key: string): string | null => {
    if (!search || !key) {
      return null;
    }

    const params = new URLSearchParams(search);

    if (!params.has(key)) {
      return null;
    }

    return params.get(key);
  };

  static clearAllSearchParams = (
    navigate: NavigateFunction,
    location: Location
  ) => {
    navigate(location.pathname, { replace: true });
  };
}

export default UrlHelper;
